import { createFileRoute } from '@tanstack/react-router';
import clsx from 'clsx';
import React from 'react';

import { Button, ButtonGroup } from '@/common/components/button';
import { Heading, Subheading } from '@/common/components/heading';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@/common/components/table';

export const Route = createFileRoute('/applications/$application-id/confirm')({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <div className="p-8">
      <Heading>Review Summary</Heading>

      <div>
        <section className="mt-6">
          <Subheading>Connect Date</Subheading>
          Connection requested for service starting on <strong className="font-black">7/4/2025</strong>.<br/>
          <em className="text-sm">*Same day connection is not guaranteed.</em>
        </section>

        <section className="mt-6">
          <Subheading>Service Address</Subheading>
          4500 Natural Bridge Rd<br/>
          Tallahassee, FL 32305
        </section>

        <section className="mt-6">
          <Subheading>Billing Options</Subheading>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Service</TableCell>
                <TableCell>Billing Option</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <StrikableText strike={true}>Meter #230032</StrikableText>
                </TableCell>
                <TableCell>
                  <StrikableText strike={true}>Standard</StrikableText>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </section>
      </div>

      <ButtonGroup>
        <Button to="/applications/$application-id/billing-preferences" params={{ 'application-id': '1' }} outline>Back</Button>
        <Button to="/applications/$application-id/sign" params={{ 'application-id': '1' }}>Next</Button>
      </ButtonGroup>
    </div>
  );
}

function StrikableText({ strike, children }: { strike: boolean; children: React.ReactNode }) {
  return (
    <span className={clsx(strike && 'line-through')}>
      {children}
    </span>
  );
}
